import { createFileRoute } from "@tanstack/react-router";
import { StudyMaterialsRoot } from "@/components/study-materials/root";
import {
	type StudyMaterialsFilterData,
	StudyMaterialsFilterSchema,
} from "@/types/study-materials";

export const Route = createFileRoute("/_app/painel/materiais-de-estudo/")({
	validateSearch: (search) => StudyMaterialsFilterSchema.parse(search || {}),
	component: MateriaisDeEstudoIndexPage,
});

function MateriaisDeEstudoIndexPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	return (
		<StudyMaterialsRoot
			search={search}
			onSearchChange={(
				updater: (old: StudyMaterialsFilterData) => StudyMaterialsFilterData,
				options?: { replace?: boolean },
			) => navigate({ search: updater, replace: options?.replace })}
		/>
	);
}
